const initialState = {
    pathologyPermissionsView:{},
    pathologyListsView: [],
    pathologyStatusView: [],
    changedPathologyStatusView : [],
    loadingPathologyView: false,
    errorsPathologyView: {},
    messageView:"",
    pathologyIdView :'',
    pathologyDetailsView :[],
    pathologyViewDetails :[],
    radiologyPathologyAddressView :[],
    errorsBasicView:{},
    errorsRemarkView:{},
    errorsAlertView:{},
    errorsBlackListView:{},
    errorsGRIView:{},
    errorsRateView:{},
}

const  pathologyReducerView = (state = initialState, action) => {
    switch (action.type) {
        case "GET_PATHOLOGYLIST_PENDING_VIEW":
        case "ADD_PATHOLOGY_PENDING_VIEW":
        case "UPDATE_PATHOLOGY_PENDING_VIEW":
        case "UPDATE_PATHOLOGY_STATUS_PENDING_VIEW":
        case "DELETE_PATHOLOGY_PENDING_VIEW":
        case "GET_PATHOLOGYLISTBYID_PENDING_VIEW":
        case "GET_PATHOLOGYVIEWLISTBYID_PENDING":
        case "UPDATE_PATHOLOGY_OWNER_PENDING_VIEW":
        case "UPDATE_PATHOLOGY_LICENSE_PENDING_VIEW":
        case "UPDATE_PATHOLOGY_HOSPITAL_PENDING_VIEW":
        case "UPDATE_PATHOLOGY_RATE_PENDING_VIEW":
        case "UPDATE_PATHOLOGY_REMARK_PENDING_VIEW":
            return { ...state, loadingPathologyView: true };
        case "SET_MESSAGE_VIEW":
            return { ...state,
                messageView:action.payload 
            };
        case "EDIT_PATHOLOGY_FORM_CLOSED_VIEW":
            return { 
                ...state, 
                pathologyIdView:"",
                pathologyDetailsView :[],
                radiologyPathologyAddressView :[],
                errorsBasicView:{},
                errorsRemarkView:{},
                errorsAlertView:{},
                errorsBlackListView:{},
                errorsGRIView:{},
                errorsRateView:{},
                errorsPathologyView:{}
            };
        case "EDIT_PATHOLOGY_FORM_FULFILLED_VIEW":
            return { 
                ...state, 
                pathologyIdView:action.payload,
                messageView:"",
                errorsPathologyView:{}
            };
        case "GET_PATHOLOGYLIST_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                pathologyListsView: action.payload,
                pathologyCountView: action.count,
                pathologyPermissionsView:action.permissions,
                errorsPathologyView:{}
            };

        case "ADD_PATHOLOGY_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                pathologyDetailsView: action.payload?.data,
                pathologyIdView: action.payload?.data?.id,
                radiologyPathologyAddressView: action.payload?.radiologyPathologyAddressView,
                messageView: action.payload?.messageView,
                changedPathologyStatusView: action.payload,
                errorsBasicView:{},
                otherErrorView:{},
                errorsPathologyView:{}
            };

        case "UPDATE_PATHOLOGY_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                pathologyDetailsView: action.payload?.data,
                pathologyIdView: action.payload?.data?.id,
                radiologyPathologyAddressView: action.payload?.radiologyPathologyAddressView,
                messageView: action.payload?.messageView,
                changedPathologyStatusView: action.payload,
                errorsBasicView:{},
                errorsPathologyView:{}
            };
        case "UPDATE_PATHOLOGY_OWNER_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                messageView: action.payload?.messageView,
                changedPathologyStatusView: action.payload,
                errorsPathologyView:{},
            };
        case "UPDATE_PATHOLOGY_LICENSE_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                messageView: action.payload?.messageView,
                changedPathologyStatusView: action.payload,
                errorsPathologyView:{},
            };
        case "UPDATE_PATHOLOGY_HOSPITAL_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                messageView: action.payload?.messageView,
                changedPathologyStatusView: action.payload,
                errorsPathologyView:{},
            };
        case "UPDATE_PATHOLOGY_REMARK_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                messageView: action.payload?.messageView,
                changedPathologyStatusView: action.payload,
                errorsRemarkView:{},
                errorsPathologyView:{}
            }; 
            case "UPDATE_PATHOLOGY_ALERT_FULFILLED_VIEW":
                return {
                    ...state,
                    loadingPathologyView: false,
                    messageView: action.payload?.messageView,
                    changedPathologyStatusView: action.payload,
                    errorsAlertView:{},
                    errorsPathologyView:{}
                };
                case "UPDATE_PATHOLOGY_BLACKLIST_FULFILLED_VIEW":
                    return {
                        ...state,
                        loadingPathologyView: false,
                        messageView: action.payload?.messageView,
                        changedPathologyStatusView: action.payload,
                        errorsBlackListView:{},
                        errorsPathologyView:{}
                    };
                    case "UPDATE_PATHOLOGY_GRI_FULFILLED_VIEW":
                        return {
                            ...state,
                            loadingPathologyView: false,
                            messageView: action.payload?.messageView,
                            changedPathologyStatusView: action.payload,
                            errorsGRIView:{},
                            errorsPathologyView:{}
                        };
                    
        case "UPDATE_PATHOLOGY_RATE_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                messageView: action.payload?.messageView,
                changedPathologyStatusView: action.payload,
                errorsRateView:{},
                errorsPathologyView:{}
            };

        case "UPDATE_PATHOLOGY_STATUS_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                changedPathologyStatusView: action.payload,
                messageView: action.payload?.messageView,
                errorsPathologyView:{}
            };

        case "GET_PATHOLOGYLISTBYID_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                pathologyDetailsView: action.payload,
                pathologyIdView: action.payload?.id,
                radiologyPathologyAddressView: action.payload?.RadiologyPathologyAddress,
                changedPathologyStatusView: action.payload,
                errorsPathologyView:{}
            };

        case "GET_PATHOLOGYVIEWLISTBYID_FULFILLED":
            return {
                ...state,
                loadingPathologyView: false,
                pathologyViewDetails: action.payload,
            };

        case "DELETE_PATHOLOGY_FULFILLED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                messageView: action.payload?.messageView,
                errorsPathologyView:{}
            };

        case "RESET_DELETE_PATHOLOGYS_STATUS_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                changedPathologyStatusView: [],
                errorsPathologyView:{}
            };

        case "GET_PATHOLOGYLIST_REJECTED_VIEW":
        case "UPDATE_PATHOLOGY_STATUS_REJECTED_VIEW ":
        case "DELETE_PATHOLOGY_REJECTED_VIEW":
        case "GET_PATHOLOGYLISTBYID_REJECTED_VIEW":
        case "GET_PATHOLOGYVIEWLISTBYID_REJECTED":
        case "UPDATE_PATHOLOGY_OWNER_REJECTED_VIEW":
        case "UPDATE_PATHOLOGY_LICENSE_REJECTED_VIEW":
        case "UPDATE_PATHOLOGY_HOSPITAL_REJECTED_VIEW":
        case "UPDATE_PATHOLOGY_HOSPITAL_REJECTED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                errorsPathologyView: action.payload
            };

        case "ADD_PATHOLOGY_REJECTED_VIEW":
        case "UPDATE_PATHOLOGY_REJECTED":
            return {
                ...state,
                loadingPathologyView: false,
                errorsBasicView: action.payload?.data,
                errorsPathologyView: action.payload,
            };
        case "UPDATE_PATHOLOGY_REMARK_REJECTED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                errorsRemarkView: action.payload,
            };
            
            case "UPDATE_PATHOLOGY_ALERT_REJECTED_VIEW":
                return {
                    ...state,
                    loadingPathologyView: false,
                    errorsAlertView:action.payload,
                };  
                case "UPDATE_PATHOLOGY_BLACKLIST_REJECTED_VIEW":
                    return {
                        ...state,
                        loadingPathologyView: false,
                        errorsBlackListView: action.payload,
                    };    
                    case "UPDATE_PATHOLOGY_GRI_REJECTED_VIEW":
                        return {
                            ...state,
                            loadingPathologyView: false,
                            errorsGRIView: action.payload,
                        };    
        case "UPDATE_PATHOLOGY_RATE_REJECTED_VIEW":
            return {
                ...state,
                loadingPathologyView: false,
                errorsRateView: action.payload,
            };
        default:
            return state;
    }
}

export default pathologyReducerView;